<template lang="html">
  <b-form id="products-results-page" @submit="onSubmit">

    <section class="products-section">
      <div class="container oversized-container">
        <div class="row">
          <div class="col-12 box-breadcrumb-s1" v-if="isLoading == false">
            <span>Home</span>
            <span>Productos</span>
            <router-link to="" v-if="formSearch.category.length == 1">{{categorydata.name}}</router-link>
            <router-link to="" v-else-if="formSearch.category.length > 1">{{categorydata}}</router-link>
          </div>
        </div>

        <div class="row">
          <!-- Mobile filters -->
          <div class="col-12 col-filters-mobile">
            <div class="bg-filter-mv" v-if="showFilters == true" @click="showFilters = false"></div>
            <a class="btn-filters" @click="showFilters = !showFilters">
              <i class="fas fa-filter"></i><span>Ver filtros</span>
            </a>
          </div>
          <!--  -->

          <!-- Col filters -->
          <div class="col-lg col-filters" v-bind:class="{ 'show-filters': showFilters == true }">
            <h4 class="d-lg-none _title">
              <span><strong>Filtrar</strong></span>
              <a class="btn-hide" @click="showFilters = false"><i class="fas fa-chevron-left"></i></a>
            </h4>

            <div class="filters-container">
              <div class="box-filters">
                <h6 class="group-f-title">Categoría</h6>

                <b-form-group class="box-filters-group" v-slot="{ ariaDescribedby }">
                  <b-form-checkbox-group
                    v-model="formSearch.category"
                    :aria-describedby="ariaDescribedby"
                    name="fil-1"
                    @change="changeCategory()"
                    >
                    <b-form-checkbox
                      :value="c.id"
                      v-for="(c, cInx) in categories"
                      :key="'cInx-'+cInx">
                      {{ c.name }}
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
              </div>

              <!-- <div class="box-filters">
                <h6 class="group-f-title">Marca</h6>

                <b-form-group class="box-filters-group" v-slot="{ ariaDescribedby }">
                  <b-form-checkbox-group
                    v-model="formSearch.brand"
                    :aria-describedby="ariaDescribedby"
                    name="fil-2">
                    <b-form-checkbox
                      :value="b.id"
                      v-for="(b, bInx) in brands"
                      :key="'bInx-'+bInx">
                      {{ b.name }}
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
              </div> -->

              <!-- <div class="box-filters">
                <h6 class="group-f-title">Precio</h6>

                <b-form-group class="box-filters-group" v-slot="{ ariaDescribedby }">
                  <b-form-radio-group
                    v-model="formSearch.price"
                    :aria-describedby="ariaDescribedby"
                    name="fil-3">
                    <b-form-radio
                      :value="p.id"
                      v-for="(p, pInx) in price"
                      :key="'pInx-'+pInx">
                      {{ p.name }}
                    </b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
              </div> -->

              <!-- <div class="box-filters">
                <h6 class="group-f-title">Descuentos</h6>

                <b-form-group class="box-filters-group" v-slot="{ ariaDescribedby }">
                  <b-form-radio-group
                    v-model="formSearch.discount"
                    :aria-describedby="ariaDescribedby"
                    name="fil-4">
                    <b-form-radio
                      :value="d.id"
                      v-for="(d, dInx) in discounts"
                      :key="'dInx-'+dInx">
                      {{ d.name }}
                    </b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
              </div> -->

            </div>
          </div>
          <!--  -->

          <!-- Col products -->
          <div class="col-lg col-results" v-if="isLoading == false">
            <div class="row" v-bind:class="{ 'justify-content-center' : products.length <= 3 }">
              <div class="col-12 col-title col-w-image" v-if="formSearch.category.length == 1">
                <div class="box-image">
                  <img :src="categorydata.imageUrl">
                </div>

                <div class="box-text">
                  <div>
                    <h2 class="mb-1 title-s1">{{categorydata.name}}</h2>
                    <p v-bind:class="{ 'text-sm' : categorydata.description.length >= 120 }">{{categorydata.description}}</p>
                  </div>
                </div>
              </div>
              <div class="col-12 col-title" v-else-if="formSearch.category.length > 1">
                <h2 class="title-s1">{{categorydata}}</h2>
              </div>
              <div class="col-12 col-title" v-else>
                <h2 class="title-s1">Resultados</h2>
              </div>

              <BoxProductComponent :css="'col-sm-6 col-lg-4'" :product="p" v-for="(p, pInx) in products" :key="'pInx-'+pInx"></BoxProductComponent>
            </div>

            <div class="row mt-4" v-if="pagination.total_products > 6">
              <div class="col-12 text-center">
                <div class="d-inline-block mx-0 col-pagination-sample-1">
                  <b-pagination-nav :link-gen="linkGen" :number-of-pages="pagination.total" use-router></b-pagination-nav>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg col-results" v-else style="text-align: center;">
              <!-- <div class="fa-6x" ><i class="fas fa-spinner fa-pulse"></i></div><br/> -->
              <p class="mb-2 text-center">
                <img class="img-fluid" src="public/images/loading.gif" style="width: 410px;">
              </p>

              <p style="font-size: 20px;"><b>Cargando ...</b></p>
          </div>
          <!--  -->

        </div>
      </div>
    </section>

  </b-form>
</template>

<script>
import BoxProductComponent from './box-product-component.vue';
export default {
  components: {
    BoxProductComponent
  },

  data() {
    return {
      showFilters: false,

      categories: [
        { id: 1, name: 'Categoría 1' },
        { id: 10,name: 'Categoría 2' },
        { id: 3, name: 'Categoría 3' },
        { id: 4, name: 'Categoría 4' },
        { id: 5, name: 'Categoría 5' },
        { id: 6, name: 'Categoría 6' },
        { id: 7, name: 'Categoría 7' },
        { id: 8, name: 'Categoría 8' },
        { id: 9, name: 'Categoría 9 y más' },
      ],

      brands: [
        { id: 1, name: 'Royal Canin' },
        { id: 2, name: 'Hils' },
        { id: 3, name: 'Purina Pro Plan' },
        { id: 4, name: 'Pal perro' },
        { id: 5, name: 'Instinct' },
        { id: 6, name: 'Dog Chow' },
        { id: 7, name: 'Nupec' },
      ],

      price: [
        { id: 1, name: '$0 - $299' },
        { id: 2, name: '$300 - $599' },
        { id: 3, name: '$600 - $999' },
        { id: 4, name: '$1,000 - $1,999' },
        { id: 5, name: '$2,000 - $2,999' },
        { id: 6, name: '$3,000 o más' },
      ],

      discounts: [
        { id: 1, name: '10%' },
        { id: 2, name: '20%' },
        { id: 3, name: '30%' },
      ],

      formSearch: {
        keywords: null,
        order: 5,
        category: [],
        brand:[],
        price: null,
        discount: null,
        subcategory:null,

      },

      products: [],

      pagination:{
        currentpage: 1,
        total: 1,
        total_products: 16,
        number: 10
      },
      categories:[],
      categorydata:null,
      isLoading:true,
    }
  },
  watch:{
    '$route':function(){
      var checkall = true;
      if(this.$route.query.page){
        this.pagination.currentpage = this.$route.query.page;
      }
      else{
        this.pagination.currentpage = 1;
      }

      
      if (this.$route.query.categories_id) {
          if(this.$route.query.categories_id != 'null'){
              this.formSearch.category = this.$route.query.categories_id.split(","); 
          }
      }
      else{
        this.formSearch.category = [];
      }
      if (this.$route.params.id) {
        this.formSearch.category.push(this.$root._getURLID(this.$route.params.id));
      }
      
      if (this.$route.params.sub) {
        if(this.formSearch.subcategory){

        }
        else{
          this.formSearch.subcategory = this.$root._getURLID(this.$route.params.sub);
        }

      }
      else{
        this.formSearch.subcategory = [];
      }
      if (this.$route.query.keywords) {
          this.formSearch.keywords = this.$route.query.keywords;
      }
      else{
        this.formSearch.keywords = null;
      }
      

      /*if(this.formSearch.category.length > 1){

      }
      else{
        this.formSearch = {
          category: [],
          subcategory:null
        };
      }*/
      this.getProducts();
    }

  },
  methods: {
    geBrands(){
      axios.get(tools.url('/api/brands')).then(({data}) =>{
        this.brands = data;
      });
    },
    linkGen(pageNum) {
      return pageNum === 1 
        ? `?keywords=${this.formSearch.keywords}&categories_id=${this.formSearch.category}`
        : `?page=${pageNum}&keywords=${this.formSearch.keywords}&categories_id=${this.formSearch.category}`;
    },

    onSubmit(event) {
      event.preventDefault();
    },

    getProducts: function(){
        this.isLoading = true;
      axios.post(tools.url('/api/products?page=' + this.$route.query.page+'&keywords='+this.formSearch.keywords+'&categories_id='+this.formSearch.category)).then(({data}) =>{
        this.products = data.data;
        this.pagination.total = data.last_page;
        this.pagination.total_products = data.total;
        this.isLoading = false;
        this.categorydata = null;
        for (let x = 0; x < this.categories.length; x++) {
              if(this.formSearch.category.length == 1){
                if(this.categories[x]['id'] == this.formSearch.category[0]){
                    this.categorydata = this.categories[x];

                }
              }
              else if(this.formSearch.category.length > 1){

                for (let z = 0; z < this.formSearch.category.length; z++) {
                    if(this.categories[x]['id'] == this.formSearch.category[z]){
                      if(this.categorydata == null){
                        this.categorydata = this.categories[x]['name'];
                      }
                      else{
                        this.categorydata = this.categorydata+','+this.categories[x]['name'];
                      }

                    }
                }

              }


            }
      }).catch((error)=>{
        this.isLoading = false;
      });
    },

    init(){
      var checkall = true;
      if(this.$route.query.page){
        this.pagination.currentpage = this.$route.query.page;
      }
      else{
        this.pagination.currentpage = 1;
      }

      
      if (this.$route.query.categories_id) {
        if(this.$route.query.categories_id != 'null'){
          this.formSearch.category = this.$route.query.categories_id.split(",");
          checkall = false;
        }
      }
      if (this.$route.params.id) {
        
        this.formSearch.category.push(this.$root._getURLID(this.$route.params.id));
        

        checkall = false;
      }
      
      if (this.$route.params.sub) {
        if(this.formSearch.subcategory){

        }
        else{
          this.formSearch.subcategory = this.$root._getURLID(this.$route.params.sub);
        }

        checkall = false;
      }
      if (this.$route.query.keywords) {
        this.formSearch.keywords = this.$route.query.keywords;
        checkall = false;
      }
      if (checkall == true) {
        //this.getProducts();
      }

      this.getProducts();


      // setTimeout(()=> {

      // }, 2000);
    },
    getCategories(){
        axios.get(tools.url("/api/categories")).then((response)=>{
            this.categories=response.data;
            this.categorydata = null;
            for (let x = 0; x < this.categories.length; x++) {
              if(this.formSearch.category.length == 1){
                if(this.categories[x]['id'] == this.formSearch.category[0]){
                    this.categorydata = this.categories[x];

                }
              }
              else if(this.formSearch.category.length > 1){

                for (let z = 0; z < this.formSearch.category.length; z++) {
                    if(this.categories[x]['id'] == this.formSearch.category[z]){
                      if(this.categorydata == null){
                        this.categorydata = this.categories[x]['name'];
                      }
                      else{
                        this.categorydata = this.categorydata+','+this.categories[x]['name'];
                      }


                    }
                }

              }


            }
          }).catch((error)=>{
          });
    },
    changeCategory(){
      this.$router.push('/productos?keywords='+this.formSearch.keywords+'&&categories_id='+this.formSearch.category);
      this.getProducts();
    }
  },

  mounted() {
    this.getCategories();
    // this.geBrands();
     this.init();
  }
}
</script>
